import React from 'react';

import {useViewerInfo} from '../../../../../../common/hooks/useViewerInfo';
import {CallsPageLoadViewWithUser} from './CallsPageLoadViewWithUser';

type CallsPageLoadViewProps = {
  entity: string;
  project: string;
  tab: string;
  view?: string;
};

export const CallsPageLoadView = ({
  entity,
  project,
  tab,
  view,
}: CallsPageLoadViewProps) => {
  const {loading: loadingUserInfo, userInfo} = useViewerInfo();

  return (
    <CallsPageLoadViewWithUser
      entity={entity}
      project={project}
      tab={tab}
      view={view}
      userInfo={loadingUserInfo ? null : userInfo}
    />
  );
};
